<div id="models" class="tab-pane fade active in">
    <div style="width:35%;float:left;">
        <h3 class="heading4">Add New Model</h3>
        <br>
        <form #myForm1="ngForm" (submit)= "ModelCreate();myForm1.reset()" >
          <!-- <input name="__RequestVerificationToken" type="hidden" 
          value="NpwP3KH-BGv0_SW6sL5geeIsdR5uankL_KUQF8hP0tyNffpiCb50mez9K-rRzUluURdn5DxbTi9xae3eYJ3nkT-dIn6hclQArX7XqAEBt7A1"> -->
          <div class="form-horizontal">

                <div class="form-group">
                    <div class="col-md-10">
                        <input class="pagefield text-box single-line" id="Model_ModelName" [(ngModel)]="ModelName" name="ModelName"
                             placeholder="Enter Model Name here" style="padding:15px;width:75%;background-color:#F9f9f9 !important;border:none;margin-bottom:8px;" type="text" value="">
                        <span class="field-validation-valid text-danger" data-valmsg-for="ModelName" data-valmsg-replace="true"></span>
                    </div>
                </div>

                <div class="form-group">
                    <div class="col-md-10">
                        <input class="pagefield text-box single-line" id="Model_Description" [(ngModel)]="Description" name="Desc" placeholder="Enter Model Description" style="padding:30px 15px;width:75%;background-color:#F9f9f9 !important;border:none;" type="text" value="">
                        <span class="field-validation-valid text-danger" data-valmsg-for="Description" data-valmsg-replace="true"></span>
                    </div>
                </div>
                <br>
                <div class="form-group">
                    <div class="col-md-10">
                        <input class="pagefield text-box single-line" id="Model_ThresholdProbability" [(ngModel)]="ThresholdProbability" name="ThresholdProbability" placeholder="Enter Threshold Probability here" style="padding:15px;width:75%;background-color:#F9f9f9 !important;border:none;margin-bottom:8px;" type="text" value="">
                        <span class="field-validation-valid text-danger" data-valmsg-for="ThresholdProbability" data-valmsg-replace="true"></span>
                    </div>
                </div>
                <br>
                <div class="form-group">
                    <div class="col-md-10">
                        <label>Associated Sector Name</label>
                        <select class="form-control" id="Sectors" [(ngModel)]="SectorName" name="SectorName" style="width: 75%">
                            <option value="">Choose Sector</option>
                            <option option *ngFor="let sec of sectorlist"  value={{sec.SectorName}} >{{sec.SectorName}}</option>


                        </select>

                        <span class="field-validation-valid text-danger" data-valmsg-for="SectorName" data-valmsg-replace="true"></span>
                    </div>
                </div>
                <br>
                <div class="form-group">
                    <div class="col-md-10">
                        <input type="submit" value="Add Model" class="btn btn-default buttonStyle">
                    </div>
                </div>
            </div>
        </form>
        <br>


        <br>
        <br>
    </div>

    <div style="width:55%;float:right;border-left: #eee solid 2px; min-height:600px;padding-left:30px;">
        <br>
        <br>

        

        <table class="table table-bordered table-hover">
            <thead>
                

                <tr style="background-color:#F9f9f9;">
                    <th>
                        <div class="center"><b>Model Name</b></div >
                    </th>
                    <th><div class="center"><b>Sector Name</b></div ></th>
                    <th><div class="center"><b>Threshold Probability</b></div ></th>
                    <th>
                        <div class="center"><b>Status</b></div >
                    </th>
                    <th>
                        <div class="center"><b>Error Message (if any)</b></div >
                    </th>
                    <th>
                        <div class="center"><b>Manage</b></div >
                    </th>


                </tr>
            </thead>
            <tbody style="text-align:center;">
                    <tr *ngFor="let mod of modellist">
                        <td>
                            {{mod.ModelName}}
                        </td>

                        <td>
                            {{mod.SectorName}}
                        </td>
                        <td>
                            {{mod.ThresholdProbability}}
                        </td>
                        <td>
                            {{mod.STATUS}}
                        </td>
                        <td>
                            {{mod.ERROR_MESSAGE}}
                        </td>
                        <td>

                            <!-- <a (click)="ModelEdit(mod)" class="modal-link"><span class="glyphicon glyphicon-pencil" style="color:#666;"></span></a>&nbsp;&nbsp; -->
                            <a (click)="showConfirm(mod)" class="modal-link"><span class="glyphicon glyphicon-trash" style="color:#666;"></span></a>
                        </td>
                    </tr>
                    

            </tbody>
        </table>
    </div>
</div>